<div class="filter-bar-container">
  <div class="content">
    <ng-content></ng-content>
    <div class="filter-section">
      <div class="filter-bar">
        <div class="filter" *ngIf="filterVisible">
          <div class="active-filters">
            <div class="header">
              <div class="headline">{{ 'filter.active.headline' | translate }}</div>
              <div class="button" (click)="deleteAllFilter()"> {{ 'filter.active.button.delete' | translate }}</div>
            </div>
            <div class="activ-filter-list">
              <ng-container *ngFor="let item of filter">
                <ng-container *ngFor="let value of item.values">
                  <div class="filter-item" *ngIf="value.selected">
                    <span>
                       {{ value.name }}
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" (click)="removeFilter(value.query.query.value)">
                        <path fill="#FFF" fill-rule="evenodd" d="M7.946 0.861L7.138 0.053 4 3.192 0.862 0.053 0.054 0.861 3.192 4 0.054 7.139 0.862 7.947 4 4.808 7.138 7.947 7.946 7.139 4.808 4z" transform="translate(4 4)"/>
                    </svg>
                    </span>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </div>
          <div class="bar">
            <kion-filter-list-item *ngFor="let filterValue of filter" [item]="filterValue" (boxToggled)="boxToggled($event)"></kion-filter-list-item>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
